<template>
  <!-- <el-dialog title="友情提示" class="warning-dialog" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
    <div class="sensetive-word-modal">
      <div class="modal-body">
        此功能仅对部分用户开放，可点击申请使用~
      </div>
      <div class="btn-wrapper">
        <div class="btn cancel" @click="handleClose">取 消</div>
        <div class="btn" @click="dialogApply">立即申请试用</div>
      </div>
    </div>
  </el-dialog> -->
  <el-dialog :visible.sync="dialogVisible" class="warning-dialog" top="60px" center :before-close="handleClose" width="900px">
        <div class="content-top-close" @click.stop="handleClose">
            <i class="el-icon-close"></i>
        </div>
        <iframe :src="computeUrl" width="100%" height="734px" frameborder="no" seamless marginwidth="0" marginheight="0" scrolling="no"></iframe>
    </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    computeUrl() {
      return window.location.href.includes("apre-")?'https://apre-' + 'so.quandashi.com/warning':'https://' + 'so.quandashi.com/warning'
    }
  },
  methods: {
    // 初始化数据
    init() {
      this.dialogVisible = true;
    },
    // 立即申请
    dialogApply() {
      this.dialogVisible = false;
      window.open(window.location.href.includes("apre-")?'https://apre-':'https://' + 'qdswww.quandashi.com/introduce/toolService', "_blank")
    },
    handleClose() {
      this.dialogVisible = false;
    }
  },
};
</script>
<style>
.warning-dialog {
  z-index: 999;

}

.warning-dialog .content-top-close {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #a39683;
  cursor: pointer;
  font-size: 20px;
}

.warning-dialog .el-dialog__headerbtn {
  top: 0;
}

.warning-dialog .sim-title {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 16px;
  color: #333;
}

.warning-dialog .el-dialog__header {
  display: none;
  height: 48px;
  line-height: 48px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(12, 27, 50, 0.1);
  border-radius: 2px 2px 0px 0px;
  margin: 0;
  padding: 0;
  padding-left: 20px;
  font-size: 16px;
  color: #222222;
}

.warning-dialog .el-dialog__body {
  padding: 0 !important;
}

.warning-dialog .modal-body {
  text-align: center;
}

.warning-dialog .btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.warning-dialog .btn-wrapper .btn {
  width: 120px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: #ff7200;
  border-radius: 2px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.warning-dialog .btn-wrapper .btn:hover {
  background: rgba(255, 114, 0, 0.8);
}

.warning-dialog .btn-wrapper .btn:last-child {
  margin-left: 24px;
}
.warning-dialog .btn-wrapper .cancel {
  width: 80px;
  background: #ffffff;
  border: 1px solid #cccccc;
  color: #666666;
}
.warning-dialog .btn-wrapper .cancel:hover {
  border: 1px solid #ffdcc0;
  background: #fff7f1;
  color: #ff7200;
}
</style>


// WEBPACK FOOTER //
// src/components/head/plugin/warning.vue